module.exports = __webpack_public_path__ + "img/laiyuan.7357fc76.png";